import { contextFactory } from '@frontend/design-system';
import { UseSendFormsProvidersResults } from './hooks';

export const [SendFormsContext, useSendFormsContext] = contextFactory<UseSendFormsProvidersResults>();
